import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpUrlEncodingCodec } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { map, tap } from "rxjs/operators";
import { Client } from '@app/core/models/client.model';
const headers = new HttpHeaders({ "Content-Type": "application/json" });

const BASE_PATH = environment.basePath;
const REST_PATH = environment.basePathExternal

@Injectable({
  providedIn: 'root'
})
export class MasterClienteCreateUserService {

  constructor(private http: HttpClient
  ) { }

  // TODO Atualizar o endpoint quando ele for desenvolvido
  listAllClients(filter?: Client[]): Observable<Client[]> {
    return this.http.get<Client[]>(`${BASE_PATH}/bff/master/users/create/clients/list`, { headers: headers });
  }
  listAllClientsPTFCONFIG(): Observable<any[]> {
    return this.http.get<any[]>(`${BASE_PATH}/bff/master/users/create/clients/list`, { headers: headers });
  }
  getListCodeGestor(): Observable<any[]> {
    return this.http.get<any[]>(
      `${REST_PATH}/portfolioController/getGestor`).pipe(
        map((data) => {
          let listGegtor = [];
          data.forEach(element => {
            listGegtor.push({
              institutionCode: element.codeAdm,
              name: element.codeGestor
            });
          });

          return listGegtor;

        })
      )
  }
  getListCodeAdmin(): Observable<any[]> {
    return this.http.get<any[]>(
      `${REST_PATH}/portfolioController/getAdministrator`).pipe(
        map((data) => {
          let listGegtor = [];
          data.forEach(element => {
            listGegtor.push({
              institutionCode: element.codeAdm,
              name: element.codeGestor
            });
          });

          return listGegtor;

        })
      )
  }

  getConfig(): Observable<any> {
    return this.http.get(`${BASE_PATH}/bff/master/users/create/config`);
  }


  CheckEmail(email: any): Observable<boolean> {
    let params = { userEmail: email }
    return this.http.get<boolean>(`${REST_PATH}/userController/isUserAlreadyRegistred`, { params: params })
  }
  checkCpf(payload: any): Observable<boolean> {
    return this.http.post<boolean>(`${BASE_PATH}/bff/users/findByCpf/`, payload);
  }

  postUser(user: any) {
    return this.http.post(`${BASE_PATH}/bff/users/create`, user)
      .toPromise()
  }

  /**
 * Single Sign On (SSO) APIs
 */

  /**
   * API for creating user SSO
   * @param payload
   * @returns
   */
  createUserSSO(user: any, usuarioMaster: any): Observable<any> {
    let body = {}
    // if (user.cpf) {
      let cpf = user.cpf.replaceAll(".", "")
      cpf = cpf.replaceAll("-", "")
      body = {
        "cpf": cpf,
        "email": user.login,
        "idioma": user.language == "português" ? "pt-BR" : "en-US",
        "nomeUsuario": user.name,
        "perfil": user.perfil,
        "usuario":user.userSso,
        "ususarioMaster": usuarioMaster
      }

    return this.http.post(`${REST_PATH}/registerUserSSO`, body, {
      headers: headers,
    });
  }

  /**
   * API for updating user SSO
   * @param payload
   * @returns
   */
  updateUserSSO(user: any, userSso: any, usuarioMaster:any): Observable<any> {
    let body = {}
    // if (user.cpf) {
      let cpf = user.cpf.replaceAll(".", "")
      cpf = cpf.replaceAll("-", "")
      body = {
        "cpf": cpf,
        "email": user.login,
        "idioma": user.language == "português" ? "pt-BR" : "en-US",
        "nomeUsuario": user.name,
        "perfil": user.perfil,
        "usuario":userSso,
        "usuarioMaster": usuarioMaster
      }
    return this.http.post(`${REST_PATH}/alterUserSSO`,body,{
      headers: headers,
    });
  }

  /**
   * API for consulting user SSO
   * @param payload
   * @returns
   */
  consultUserSSO(createUserPayload: any): Observable<any> {
    let body = {
      "usuario":createUserPayload.name,
      "usuarioMaster":createUserPayload.login,
      "cpf":createUserPayload.cpf
  }
    return this.http.post(`${REST_PATH}/consultUserSSO`,body,{
      headers: headers,
    });
  }

  /**
   * Block/unblock API for user SSO
   * @param createUserPayload
   * @returns
   */
  blockUserSSO(createUserPayload: any,usuarioMaster:any): Observable<any> {
    let body = {
      "usuario":createUserPayload.userSso,
      "usuarioMaster":usuarioMaster,
      "cpf": createUserPayload.cpf
  }
    return this.http.post(`${REST_PATH}/disableUserSSO`, body, {
      headers: headers,
    });
  }

}
